import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import AssociatedCampaignAssetForm from "./AssociatedCampaignAssetForm";
import { AssociatedCampaignAsset } from "../../store/apis/briefingApi";

interface AssociatedCampaignAssetDialogProps {
  open: boolean;
  onClose: () => void;
  briefingId: string;
  associatedId: string;
  initialAsset: AssociatedCampaignAsset | null;
  onSuccess?: () => void;
}

const AssociatedCampaignAssetDialog: React.FC<
  AssociatedCampaignAssetDialogProps
> = ({ open, onClose, briefingId, associatedId, initialAsset, onSuccess }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 700 }}>
        {initialAsset
          ? t("briefingsView.editAssetTitle", "Edit asset details")
          : t("briefingsView.createAssetTitle", "Create asset details")}
      </DialogTitle>
      <DialogContent dividers>
        <AssociatedCampaignAssetForm
          briefingId={briefingId}
          associatedId={associatedId}
          initialAsset={initialAsset}
          onSuccess={() => {
            onSuccess?.();
            onClose();
          }}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AssociatedCampaignAssetDialog;
